import axios from 'axios'

export const APIURL = process.env.REACT_APP_API_ENDPOINT

export const ME_URL = APIURL + '/api/auth/me'

/*
 * Single Login v2 / Firebase auth endpoints.
 *
 * Replaces the v1 Cognito calls (login, register, check_user_existance,
 * create_user, create_user_with_userdata, login_with_user_module,
 * login_with_user_module_with_user_data, login_using_keys). Accounts are now
 * provisioned in Single Login v2, not by this app.
 *
 * NOTE: redux/setupAxios.js does NOT unwrap response.data, so callers read
 * `response.data.status` etc. themselves.
 */

/** Direct email/password login. May return a business-selection handoff. */
export function login_with_email_and_password(data) {
	return axios.post(APIURL + '/api/auth/login_with_email_and_password', data)
}

/**
 * Business-selection step of a multi-business login. Takes the sso_token
 * handed back by login_with_email_and_password plus the chosen business uuid.
 */
export function login_to_business_with_token(data) {
	return axios.post(APIURL + '/api/auth/login_to_business_with_token', data)
}

/** SSO handoff from the v2 auth app: { token, business_id }. */
export function verify_sso_token(data) {
	return axios.post(APIURL + '/api/auth/verify_sso_token', data)
}

/**
 * App-keys login. Used by the module-click flow: clicking a module in the
 * SingleLogin user module opens this app and postMessages
 * { publicKey, privateKey } to it, rather than a module-auth token.
 */
export function login_using_keys(data) {
	return axios.post(APIURL + '/api/auth/login_using_keys', data)
}

/** Rotate the session using its refresh token. */
export function login_using_refresh_token(data) {
	return axios.post(APIURL + '/api/auth/login_using_refresh_token', data)
}

export function getUserByToken() {
	// Authorization header is fulfilled by the axios request interceptor.
	return axios.get(ME_URL)
}
